// extracted by mini-css-extract-plugin
export default {"nfpContainer":"NotFoundPage_nfpContainer__Pnx5R","nfpContent":"NotFoundPage_nfpContent__TtoIM"};